import { getDiff } from "../utils"


export const actionsColumn = [
    {
        attr: "table_name",
        attr: "table_name",
        type: 1,
        maxWidth: "34px",
        editor: false
    },
    {
        attr: "record_guid",
        attr: "record_guid",
        type: 1,
        maxWidth: "34px",
        editor: false
    },
    {
        attr: "action_type",
        attr: "action_type",
        type: 3,
        maxWidth: "34px",
        editor: false
    },
    {
        label: "old_data",
        attr: "old_data",
        type: 6,
        rows: 15,
        editor: true,
        hidden: true
    },
    {
        label: "new_data",
        attr: "new_data",
        type: 6,
        editor: true,
        rows: 15,
        hidden: true
    },
    // {
    //     label: "Changes",
    //     attr: "changes",
    //     editor: true,
    //     maxWidth: "340px",
    //     rows: 15,
    //     body: (data, field) => {

    //         const oldData = data.old_data;
    //         const newData = data.new_data;
    //         const diff = (!oldData || !newData) ? "" : getDiff(oldData, newData);
    //         return JSON.stringify(diff)
    //     }
    // },
    {
        attr: "changed_by",
        attr: "changed_by",
        type: 1,
        maxWidth: "34px",
        editor: false
    },
    {
        attr: "date_created",
        attr: "date_created",
        type: 1,
        maxWidth: "34px",
        editor: false
    }
]
